import {ColumnPicker} from './column_picker'
import {GroupingPicker} from './grouping_picker'
import {ResetTableButton} from './reset_table_button'

export {ColumnPicker, GroupingPicker}

export const AdvancedTableOptions = props => {
	return (
		<>
			<ResetTableButton {...props} />
			<ColumnPicker {...props} />
			<GroupingPicker {...props} />
		</>
	)
}
